import { ProductReviewsIoDataLoader } from 'reviews-io-product-data-loader';
if (!window.customElements.get('reviews-io-product-widget')) {
	class ReviewsIOProductWidget extends HTMLElement {
		async connectedCallback() {
			this._abort = new AbortController();
			const { signal } = this._abort;

			this.reviewsIoDataLoader = new ProductReviewsIoDataLoader({
				storeID: this.storeID,
				SKUs: this.SKUs,
				reviewsCountPerPage: this.reviewsCountPerPage,
				minRating: this.minRating,
			});
			this.productStars = document.querySelector('.ruk_rating_snippet_pdp');
			this._pageSpan = this.querySelector('[page]');
			this._prevBtn = this.querySelector('button[prev]');
			this._nextBtn = this.querySelector('button[next]');

			// summary runs in parallel — it's an independent endpoint with no shared state
			const summaryPromise = this.reviewsIoDataLoader.summary;

			// fetchPhotoReviews first: pre-populates _pageCache so getReviews() hits cache
			const photoReviews = await this.reviewsIoDataLoader.fetchPhotoReviews(15);
			const data = await this.reviewsIoDataLoader.getReviews();
			const summary = await summaryPromise;
			const header = this.querySelector('reviews-io-product-widget-header');
			if (header) {
				header.render({ ...summary, photoReviews: photoReviews || [] });
			}
			if (data) {
				this.renderReviews(data.reviews);
			}
			if (!data?.reviews?.length) {
				this?.parentElement?.classList.add('hidden');
			}
			this._updatePageDisplay();

			this._nextBtn.addEventListener('click', () => this._changePage('next'), { signal });
			this._prevBtn.addEventListener('click', () => this._changePage('prev'), { signal });
			this.productStars?.addEventListener('click', this.anchor.bind(this), { signal });
		}

		disconnectedCallback() {
			this._abort?.abort();
		}
		anchor() {
			this.scrollIntoView({ behavior: 'smooth' });
		}
		async _changePage(direction) {
			this._setLoading(true);
			const pageData = await (direction === 'next'
				? this.reviewsIoDataLoader.nextPage()
				: this.reviewsIoDataLoader.prevPage());
			if (pageData) this.renderReviews(pageData.reviews);
			this._setLoading(false);
			this.scrollIntoView({ behavior: 'smooth' });
			this._updatePageDisplay();
		}

		_setLoading(loading) {
			this._prevBtn.disabled = loading;
			this._nextBtn.disabled = loading;
		}

		_updatePageDisplay() {
			if (this._pageSpan) {
				this._pageSpan.textContent = this.reviewsIoDataLoader.currentPage;
			}
			if (this._prevBtn) {
				this._prevBtn.disabled = this.reviewsIoDataLoader.currentPage <= 1;
			}
			if (this._nextBtn) {
				this._nextBtn.disabled = !this.reviewsIoDataLoader.hasNextPage;
			}
		}

		renderReviews(reviews) {
			const container = this.querySelector('.reviews-io-product-widget__list');
			if (!container) return;
			container.innerHTML = '';
			reviews.forEach((review) => {
				const item = document.createElement('review-row-item');
				item.render({
					id: review.id || '',
					rating: review.rating || 0,
					title: review.title || '',
					comments: review.comments || '',
					author: review.author || {},
					attributes: review.attributes || [],
					photos: review.photos || [],
					time_ago: review.time_ago || '', // time_ago is not localized
					date_created: review.date_created || '',
					verified: !!review.verified,
				});
				container.appendChild(item);
			});
		}

		get storeID() {
			return this.getAttribute('store-id');
		}
		get SKUs() {
			return this.getAttribute('sku');
		}
		get reviewsCountPerPage() {
			return parseInt(this.getAttribute('reviews-count-per-page'), 10);
		}
		get minRating() {
			return parseInt(this.getAttribute('min-rating'), 10);
		}
	}
	window.customElements.define('reviews-io-product-widget', ReviewsIOProductWidget);
}
